//TODO: the icon is the same as the one for pdf mode -- alter it to make it more accessible
require('./style.less');
module.exports = require('./template.hbs');


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/views/nav/navBar/comboPdf/pdfDropDownButton/bundle.js
 ** module id = 701
 ** module chunks = 0
 **/